var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuckwheat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C8078;}\n\t.st1{fill:#E38D56;}\n\t.st2{fill:#B87053;}\n\t.st3{fill:#5E372B;}\n\t.st4{fill:#EDA77B;}\n\t.st5{fill:#FAC493;}\n\t.st6{fill:#ECA469;}\n\t.st7{fill:#BF7663;}\n\t.st8{fill:#FBD5BE;}\n\t.st9{fill:#CA7038;}\n\t.st10{fill:#DF844F;}\n\t.st11{fill:#6F4E49;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.71,64.4c-2.92-1.14-5.57-2.82-7.84-4.97c-11.8-11.2-25.17,1.71-26.75,16.62 c-1.73,16.26,6.5,23.99,6.5,23.99s10.5,4.15,24.47-4.35C132.89,87.89,138.87,70.29,123.71,64.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M123.71,64.4c-0.05-0.02-0.1-0.05-0.15-0.06c7.35,7.64,1.42,21.09-9.34,27.63c-9.06,5.51-16.65,5.7-20.87,5.16 c1.24,1.95,2.26,2.91,2.26,2.91s10.5,4.15,24.47-4.35C132.89,87.89,138.87,70.29,123.71,64.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.28,82.17c-6.47,10.2-12.14,18.2-12.67,17.86c-0.53-0.34,4.28-8.88,10.75-19.08 c6.47-10.2,12.14-18.2,12.67-17.86C119.57,63.43,114.75,71.97,108.28,82.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M126.85,65.98c-0.93-0.59-1.96-1.12-3.14-1.58c-2.92-1.14-5.57-2.82-7.84-4.97c-0.92-0.87-1.84-1.58-2.77-2.17 c-0.37,3.34,1.12,6.75,4.14,8.67C120.27,67.84,123.99,67.74,126.85,65.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M110.24,60.12c-4.05,2.73-7.77,7.2-9.6,11.75c-2.4,4.74-3.52,10-5.83,14.75c-1.57-5.58-0.73-11.56,1.67-16.76 C98.72,64.99,104.36,59.34,110.24,60.12z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M147.98,140.71c1.34-2.83,3.2-5.36,5.51-7.47c12-10.98,0.06-25.23-14.7-27.85 c-16.1-2.87-24.39,4.79-24.39,4.79s-4.87,10.18,2.62,24.71C123.89,148.22,141.03,155.42,147.98,140.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M147.98,140.71c0.02-0.05,0.05-0.09,0.07-0.14c-8.14,6.8-21.14-0.07-26.91-11.26 c-4.86-9.42-4.52-17.01-3.68-21.18c-2.03,1.1-3.06,2.05-3.06,2.05s-4.87,10.18,2.62,24.71 C123.89,148.22,141.03,155.42,147.98,140.71z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5936 -0.8048 0.8048 0.5936 -45.4661 156.2821)",
    className: "st6",
    cx: 132.01,
    cy: 123.16,
    rx: 1.14,
    ry: 21.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M146.18,143.73c0.65-0.88,1.26-1.88,1.8-3.02c1.34-2.83,3.2-5.36,5.51-7.47c0.93-0.85,1.7-1.73,2.35-2.61 c-3.3-0.61-6.81,0.64-8.94,3.52C144.78,137.03,144.62,140.75,146.18,143.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M153.19,127.58c-2.44-4.23-6.63-8.25-11.04-10.4c-4.56-2.73-9.73-4.21-14.31-6.86 c5.68-1.17,11.59,0.09,16.6,2.85C149.14,115.74,154.38,121.76,153.19,127.58z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M97.34,131.65L97.34,131.65c-9.75,9.53-23.85,13.13-36.98,9.44l0,0c-2.42-0.68-4.29-2.59-4.91-5.03l0,0 c-3.37-13.21,0.56-27.22,10.31-36.75l0,0c1.8-1.75,4.39-2.42,6.81-1.74l0,0c13.13,3.68,23.29,14.09,26.67,27.3l0,0 C99.86,127.31,99.13,129.89,97.34,131.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M93.08,129.36L93.08,129.36c-7.93,7.75-19.4,10.68-30.07,7.68l0,0c-1.97-0.55-3.49-2.11-3.99-4.09v0 c-2.74-10.74,0.45-22.13,8.38-29.88l0,0c1.46-1.43,3.57-1.97,5.54-1.41l0,0c10.68,3,18.94,11.46,21.69,22.2l0,0 C95.13,125.84,94.54,127.94,93.08,129.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M71.58,116.62c-1.99-7.8-2.75-14.35-1.69-14.62c1.06-0.27,3.53,5.84,5.53,13.64L71.58,116.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M80.34,120.81c7.75,2.18,13.82,4.72,13.55,5.68c-0.27,0.96-6.78-0.02-14.53-2.2L80.34,120.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M72.54,125.95c-5.76,5.63-10.97,9.64-11.63,8.97c-0.66-0.68,3.47-5.79,9.24-11.41L72.54,125.95z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 74.82,
    cy: 121.44,
    r: 7.18
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuckwheat);
export default __webpack_public_path__ + "static/media/Buckwheat.1d7954601dbddc6fd02771b0bae019d6.svg";
export { ForwardRef as ReactComponent };